import { IsBoolean, IsEmail, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { IsPartitaIvaFormat } from '../../validation/is-partita-iva.decorator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class UpdateSupplierDto {
  @IsString()
  @IsNotEmpty()
  @IsOptional()
  name?: string;

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  @IsPartitaIvaFormat()
  vatNumber?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  address?: string;

  @IsEmail()
  @IsOptional()
  @OptionalStringTransform()
  email?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  phone?: string;

  @IsBoolean()
  @IsOptional()
  confirmDuplicate?: boolean;
}
